import React from "react";
import Grid from "../../components/Grid/Grid";
import data from "../../data/projects.json";
import "./Narratives.css";

function Narratives() {
  const items = data.filter((p) => p.category === "Narratives");
  return (
    <section className="Narratives">
      <h1 className="Narratives__title">Narratives</h1>
      {/* Full-width, single-column cards */}
      <Grid items={items} className="Grid--singleCol Grid--wide" />
    </section>
  );
}

export default Narratives;
